export default "__VITE_ASSET__CUQoz6QJ__"